import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, ZapIcon, ClockIcon } from 'lucide-react';
export function OfferSection() {
  return <section className="py-32 px-6 bg-charcoal-800 relative overflow-hidden border-t border-charcoal-700" data-id="element-100">
      {/* Intense background glow for the climax */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber/10 rounded-full blur-[150px] pointer-events-none" data-id="element-101" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-102">
        <FadeIn data-id="element-103">
          <p className="text-xl sm:text-2xl text-offwhite/90 font-light mb-8 max-w-3xl mx-auto" data-id="element-104">
            Recuperá el control de tu sistema nervioso hoy mismo por menos de lo
            que cuesta una cena que ni siquiera podrías disfrutar por el estrés.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-105">
          <div className="mb-10 flex flex-col items-center" data-id="element-106">
            <div className="inline-flex items-center gap-3 bg-mutedred/10 border border-mutedred/30 px-5 py-2.5 rounded-full mb-8" data-id="element-107">
              <span className="w-2.5 h-2.5 rounded-full bg-mutedred animate-pulse" data-id="element-108"></span>
              <span className="text-mutedred text-sm font-medium tracking-wide" data-id="element-109">
                ⏰ Este precio cierra el domingo a las 23:59. Después sube a
                $19.990.
              </span>
            </div>

            <span className="block text-offwhite/60 text-sm uppercase tracking-widest mb-2" data-id="element-110">
              Acceso inmediato por solo
            </span>
            <span className="font-heading text-7xl sm:text-8xl text-amber drop-shadow-[0_0_15px_rgba(212,168,83,0.3)] mb-4 block" data-id="element-111">
              $9.990
            </span>
            <span className="text-offwhite/80 text-lg sm:text-xl font-light" data-id="element-112">
              o{' '}
              <strong className="text-offwhite font-medium" data-id="element-113">
                3 cuotas sin interés de $3.330
              </strong>{' '}
              con Mercado Pago
            </span>

            <p className="text-mutedteal text-sm font-medium mt-6" data-id="element-114">
              🔥 Más de 500 personas ya aplicaron este protocolo este fin de
              semana.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-115">
          <div className="max-w-xl mx-auto" data-id="element-116">
            <CTAButton className="w-full mb-6" data-id="element-117">
              LO QUIERO AHORA — DESCARGA INSTANTÁNEA
            </CTAButton>

            <p className="text-amber text-lg font-medium mb-8" data-id="element-118">
              En 2 minutos lo tenés en tu mail. Así de fácil.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 pt-6 border-t border-charcoal-700/50 text-offwhite/60 text-sm" data-id="element-119">
              <span className="flex items-center gap-2" data-id="element-120">
                <ShieldCheckIcon className="w-4 h-4 text-mutedteal" data-id="element-121" /> Pago 100%
                seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-122">
                <ZapIcon className="w-4 h-4 text-amber" data-id="element-123" /> Descarga instantánea
              </span>
              <span className="flex items-center gap-2" data-id="element-124">
                <ClockIcon className="w-4 h-4 text-mutedteal" data-id="element-125" /> Acceso de por
                vida
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}